module.exports = __webpack_public_path__ + "static/img/no_shop.cae656f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/default_images/no_shop.png
// module id = HjJh
// module chunks = 91